import { isNumber } from 'fitify-types/src/type-guards/common'
import { styled } from 'styled-components'

export const PAYWALL_VERTICAL_PADDING = 24

export const LayoutWrapper = styled.div<{
  $hasCountdown: boolean
  $headerHeight?: number
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding-top: ${({ $hasCountdown, $headerHeight, theme }) => {
    if (isNumber($headerHeight)) {
      return `${$headerHeight}px`
    }
    return `${theme.sizes.headerHeight * ($hasCountdown ? 2 : 1)}rem`
  }};
`
